import { put, takeLatest } from "redux-saga/effects";

import {
  requestClientSpocList,
  requestCreateSpoc,
  requestUpdateSpoc,
  getClientSpocList
  
} from "../../../services/client-spoc";
import {
  fetchClientSpocListFailure,
  fetchClientSpocListRequest,
  fetchClientSpocListSuccess,
  fetchClientSpocLeadGenSuccess,
  fetchClientSpocLeadGenRequest,
  fetchClientSpocLeadGenFailure,
  createclientSpocRequest,
  createclientSpocSuccess,
  createclientSpocFailure,
  updateclientSpocRequest,
  updateclientSpocSuccess,
  updateclientSpocFaliure,
} from "../../reducers/client-spoc";

export function* watchClientSpocSaga() {
  yield takeLatest(fetchClientSpocListRequest, fetchClientSpocList);
  yield takeLatest(fetchClientSpocLeadGenRequest, fetchClientSpocListGen);
  yield takeLatest(createclientSpocRequest, createclientSpoc);
  yield takeLatest(updateclientSpocRequest, updateclientSpoc);
}

/**
 *
 * @param {*} param0
 */
function* fetchClientSpocList({ payload }) {
  try {
    const response = yield requestClientSpocList(payload);
    yield put(fetchClientSpocListSuccess(response));
  } catch (error) {
    yield put(fetchClientSpocListFailure("Failed to get list of ClientSpoc"));
  }
}
function* fetchClientSpocListGen({payload}){
  try{
    const response = yield getClientSpocList(payload);
    yield put(fetchClientSpocLeadGenSuccess(response))
  }catch (error){
    yield put(fetchClientSpocLeadGenFailure("Failed to get list of clientspocGen"))
  }
}

function* createclientSpoc({ payload }) {
  try {
    const response = yield requestCreateSpoc(payload);
    yield put(createclientSpocSuccess(response.data));
  } catch (error) {
    yield put(createclientSpocFailure("Failed to create ClientSpoc"));
  }
}
function* updateclientSpoc({ payload }) {
  try {
    const response = yield requestUpdateSpoc(payload);
    yield put(updateclientSpocSuccess(response.data));
  } catch (error) {
    yield put(updateclientSpocFaliure("Failed to get update ClientSpoc"));
  }
}
